/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";
import Store from "./store/store";
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("./layouts/main/Main.vue"),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/",
          redirect: "/login"
        },
        {
          path: "/canermail/:id/:islem/:mail",
          name: "caner-mail",
          component: () => import("@/views/pages/MuhasebeKategorileri.vue")
        },
        

        {
          path: "/home",
          name: "home",
          component: () => import("@/views/Home.vue")

          /*
          meta: {

            requiresAuth: true,
            //pageTitle: 'Hızlı Satış',
            rule: 'editor'
          }*/
        },

        {
          path: "/finans/cari-kartlar",
          name: "CariKartlar",
          component: () => import("@/views/finans/CariKartlar.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans", url: { name: "ProductsList" } },
              { title: "Cari Kartlar", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/finans/cari-tahsilat",
          name: "CariTahsilat",
          component: () => import("@/views/finans/CariTahsilat.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans", url: { name: "ProductsList" } },
              { title: "Cari Tahsilat", active: true }
            ],

            rule: "editor"
          }
        },
        {
          path: "/finans/gider-analizi",
          name: "GiderAnalizi",
          component: () => import("@/views/finans/GiderAnalizi.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans", url: { name: "ProductsList" } },
              { title: "Cari Kartlar", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/finans/gelir-analizi",
          name: "GelirAnalizi",
          component: () => import("@/views/finans/GelirAnalizi.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans", url: { name: "ProductsList" } },
              { title: "Cari Kartlar", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/finans/odeme-hatirlatma",
          name: "OdemeHatirlatma",
          component: () => import("@/views/finans/OdemeHatirlatma.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans", url: { name: "ProductsList" } },
              { title: "Ödeme Hatırlatma", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/finans/odeme-tahsilat-plani",
          name: "OdemeTahsilatPlani",
          component: () => import("@/views/finans/OdemeTahsilatPlani.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans", url: { name: "ProductsList" } },
              { title: "Ödeme Tahsilat Planı", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/finans/cek-raporu",
          name: "CekRaporu",
          component: () => import("@/views/finans/CekRaporu.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans", url: { name: "CekRaporu" } },
              { title: "Cek Raporu", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/finans/kasa-raporu",
          name: "KasaRaporu",
          component: () => import("@/views/finans/KasaRaporu.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans", url: { name: "KasaRaporu" } },
              { title: "Kasa Kartlar", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/finans/gelir-analizi",
          name: "GelirAnalizi",
          component: () => import("@/views/finans/GelirAnalizi.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans", url: { name: "ProductsList" } },
              { title: "Cari Kartlar", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/finans/gelir-analizi",
          name: "GelirAnalizi",
          component: () => import("@/views/finans/GelirAnalizi.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans", url: { name: "ProductsList" } },
              { title: "Cari Kartlar", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/finans/gelir-analizi",
          name: "GelirAnalizi",
          component: () => import("@/views/finans/GelirAnalizi.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans", url: { name: "ProductsList" } },
              { title: "Cari Kartlar", active: true }
            ],
            rule: "editor"
          }
        },

        {
          path: "/finans/bos-sayfa",
          name: "BosSayfa",
          component: () => import("@/views/finans/BosSayfa.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans", url: { name: "ProductsList" } },
              { title: "Cari Tahsilat", active: true }
            ],

            rule: "editor"
          }
        },
        {
          path: "/finans/tahsilat-raporu",
          name: "TahsilatRaporu",
          component: () => import("@/views/finans/TahsilatRaporu.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans", url: { name: "finans" } },
              { title: "Tahsilat Raporu", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/finans/mutabakat-raporu",
          name: "MutabakatRaporu",
          component: () => import("@/views/finans/MutabakatRaporu.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans", url: { name: "finans" } },
              { title: "Mutabakat Raporu", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/finans/finansal-rapor",
          name: "FinansalRapor",
          component: () => import("@/views/finans/FinansalRapor.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans", url: { name: "finans" } },
              { title: "Finansal Rapor", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/finans/finansal-rapor-analizi",
          name: "FinansalRapor",
          component: () => import("@/views/finans/FinansalRaporAnalizi.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans", url: { name: "finans" } },
              { title: "Finansal Rapor Analizi", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/finans/babs-islemi",
          name: "BABSIslemi",
          component: () => import("@/views/finans/BABSIslemi.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans", url: { name: "finans" } },
              { title: "Ba-Bs İşlemi ", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/finans/babs-detay",
          name: "BABSDetay",
          component: () => import("@/views/finans/BABSDetay.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans", url: { name: "finans" } },
              { title: "Ba-Bs İşlemi ", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/finans/caririsk-raporu",
          name: "CaririskRaporu",
          component: () => import("@/views/finans/CaririskRaporu.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans", url: { name: "finans" } },
              { title: "Cari Risk Raporu ", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/finans/karlilik-raporu",
          name: "KarlilikRaporu",
          component: () => import("@/views/finans/KarlilikRaporu.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Finans", url: { name: "finans" } },
              { title: "Karlılık Raporu ", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/satis/satis-faturalari",
          name: "SatisFaturalari",
          component: () => import("@/views/satis/SatisFaturalari.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Satış", url: { name: "finans" } },
              { title: "Fatura", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/satis/satis-siparisleri",
          name: "SatisSiparisleri",
          component: () => import("@/views/satis/SatisSiparisleri.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Satış", url: { name: "finans" } },
              { title: "Sipariş", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/satis/satis-teklifleri",
          name: "SatisTeklifleri",
          component: () => import("@/views/satis/SatisTeklifleri.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Satış", url: { name: "finans" } },
              { title: "Teklif", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/satis/acik-siparisler",
          name: "AcikSiparisler",
          component: () => import("@/views/satis/AcikSiparisler.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Satış", url: { name: "finans" } },
              { title: "Açık Siparişler", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/satis/bolgesel-satislar",
          name: "BolgeselSatislar",
          component: () => import("@/views/satis/BolgeselSatislar.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Satış", url: { name: "finans" } },
              { title: "Bölgesel Satışlar", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/satis/siparis-performansi",
          name: "SiparisPerformansi",
          component: () => import("@/views/satis/SiparisPerformansi.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Satış", url: { name: "finans" } },
              { title: "Sipariş Performansı", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/satis/teklif-onayi",
          name: "TeklifOnayi",
          component: () => import("@/views/satis/TeklifOnayi.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Satış", url: { name: "finans" } },
              { title: "Teklif Onayı", active: true }
            ],
            rule: "editor"
          }
        },

        {
          path: "/satinalma/satinalma-faturalari",
          name: "SatinalmaFaturalari",
          component: () => import("@/views/satinalma/SatinalmaFaturalari.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Satın Alma", url: { name: "finans" } },
              { title: "Faturaları", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/satinalma/satinalma-siparisleri",
          name: "SatinalmaSiparisleri",
          component: () => import("@/views/satinalma/SatinalmaSiparisleri.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Satın Alma", url: { name: "finans" } },
              { title: "Siparişleri", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/satinalma/satinalma-teklifleri",
          name: "SatinalmaTeklifleri",
          component: () => import("@/views/satinalma/SatinalmaTeklifleri.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Satın Alma", url: { name: "finans" } },
              { title: "Teklifleri", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/satinalma/acik-siparisler",
          name: "SatinalmaAciksiparisler",
          component: () =>
            import("@/views/satinalma/SatinalmaAciksiparisler.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Satın Alma", url: { name: "finans" } },
              { title: "Açık Siparişler", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/satinalma/siparis-performansi",
          name: "SatinalmaSiparisperformansi",
          component: () =>
            import("@/views/satinalma/SatinalmaSiparisperformansi.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Satın Alma", url: { name: "finans" } },
              { title: "Sipariş Performansı", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/satinalma/satinalma-planlama",
          name: "SatinalmaPlanlama",
          component: () => import("@/views/satinalma/SatinalmaPlanlama.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Satın Alma", url: { name: "finans" } },
              { title: "Planlama", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/satinalma/satinalma-talephavuzu",
          name: "SatinalmaTalephavuzu",
          component: () => import("@/views/satinalma/SatinalmaTalephavuzu.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Satın Alma", url: { name: "finans" } },
              { title: "Talep Havuzu", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/satinalma/iade-ariza",
          name: "SatinalmaIadeariza",
          component: () => import("@/views/satinalma/SatinalmaIadeariza.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Satın Alma", url: { name: "finans" } },
              { title: "İade Arıza", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/satinalma/iade-ariza-detay",
          name: "SatinalmaIadearizaDetay",
          component: () =>
            import("@/views/satinalma/SatinalmaIadearizaDetay.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Satın Alma", url: { name: "finans" } },
              { title: "İade Arıza Detay", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/satis/satis-siparis-teklifleri/:Ty/:ActId/:ActName/:transDate",
          name: "SatisSiparisTeklifleri",
          component: () =>
            import("@/views/satis/SatisSiparisTeklifleri.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Satın Alma", url: { name: "finans" } },
              { title: "Satış sipariş teklifleri", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/satis/satis-siparis-teklifleri/:Ty",
          name: "SatisSiparisTeklifleriTy",
          component: () =>
            import("@/views/satis/SatisSiparisTeklifleri.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Satın Alma", url: { name: "finans" } },
              { title: "Satış sipariş teklifleri", active: true }
            ],
            rule: "editor"
          }
        },


        {
          path: "/stok/stok-kartlari",
          name: "StokKartlari",
          component: () => import("@/views/stok/StokKartlar.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Stok", url: { name: "finans" } },
              { title: "Stok Kartları", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/stok/stok-envanteri",
          name: "StokEnvanteri",
          component: () => import("@/views/stok/StokEnvanteri.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Stok", url: { name: "finans" } },
              { title: "Stok Envanteri", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/stok/stok-alis-satis-raporu",
          name: "StokAlisSatisRaporu",
          component: () => import("@/views/stok/StokAlisSatisRaporu.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Stok", url: { name: "finans" } },
              { title: "Stok Alış Satış Raporu", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/stok/stok-karlilik-raporu",
          name: "StokKarlilikRaporu",
          component: () => import("@/views/stok/StokKarlilikRaporu.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Stok", url: { name: "finans" } },
              { title: "Stok Karlılık Raporu", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/stok/toplu-urun-resmi",
          name: "TopluUrunResmi",
          component: () => import("@/views/stok/TopluUrunResmi.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Stok", url: { name: "finans" } },
              { title: "Toplu Urun Resmi", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/stok/toplu-sozlesme",
          name: "TopluSozlesmeGuncelle",
          component: () => import("@/views/stok/TopluSozlesmeGuncelle.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Stok", url: { name: "finans" } },
              { title: "Toplu Sözleşme Güncelle", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/stok/firma-tanimli-alanlar",
          name: "FirmaTanimliAlanlar",
          component: () => import("@/views/stok/FirmaTanimliAlanlar.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Stok", url: { name: "finans" } },
              { title: "Firma Tanımlı Alanlar", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/stok/stok-resim-bilgileri",
          name: "StokResimBilgileri",
          component: () => import("@/views/stok/StokResimBilgileri.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Stok", url: { name: "finans" } },
              { title: "Stok Resim Bilgileri", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/stok/cross-list",
          name: "StokCrossList",
          component: () => import("@/views/stok/CrossList.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Stok", url: { name: "stok" } },
              { title: "Stok Cross List", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/crm/musteriler",
          name: "Musteriler",
          component: () => import("@/views/crm/Musteriler.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Crm", url: { name: "finans" } },
              { title: "Müşteriler", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/crm/musteriler-detay",
          name: "MusterilerDetay",
          component: () => import("@/views/crm/MusterilerDetay.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Crm", url: { name: "Musteriler" } },
              { title: "Müşteriler Detay", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/kalite-yonetimi/mal-kabul-detay",
          name: "MalKabulDetay",
          component: () => import("@/views/KaliteYonetimi/MalKabulDetay.vue")
          /*
          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Crm", url: { name: "Musteriler" } },
              { title: "Mal Kabul Detay", active: true }
            ],
            rule: "editor"
          }*/
        },
        {
          path: "/kalite-yonetimi/mal-kabul",
          name: "MalKabul",
          component: () => import("@/views/KaliteYonetimi/MalKabul.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Crm", url: { name: "Musteriler" } },
              { title: "Mal Kabul", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/kalite-yonetimi/ziyaret-raporu",
          name: "ZiyaretRaporu",
          component: () => import("@/views/KaliteYonetimi/ZiyaretRaporu.vue"),

          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Crm", url: { name: "Musteriler" } },
              { title: "Müşteriler Detay", active: true }
            ],
            rule: "editor"
          }
        },
        {
          path: "/raporlar/tum-raporlar",
          name: "Raporlar",
          component: () => import("@/views/raporlar/Raporlar.vue")
          /*
          meta: {
            breadcrumb: [
              { title: "Ana Sayfa", url: "/" },
              { title: "Crm", url: { name: "Musteriler" } },
              { title: "Mal Kabul Detay", active: true }
            ],
            rule: "editor"
          }*/
        },
        {
          path: "/page2",
          name: "page-2",
          component: () => import("./views/Page2.vue")
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        {
          path: "/odeme-hatirlatmasi/:ACTID/:GONDKEY",
          name: "odeme-hatirlatmasi",
          component: () => import("@/views/pages/OdemeHatiratmaMaili.vue")
        },
        {
          path: "teklif-onay-mesaj/:ID/:TRANSTYPE/:DOCUMENTNO/:EMAIL",
          name: "TeklifOnayMesaj",
          component: () => import("@/views/pages/TeklifOnayMesaj.vue"),

        },
        {
          path: "teklif-onay-mesaj/:ID/:TRANSTYPE/:DOCUMENTNO",
          name: "TeklifOnayMesaj",
          component: () => import("@/views/pages/TeklifOnayMesaj.vue"),

        },
        {
          path: "mutabakat-mail/:ACTID",
          name: "TeklifOnayMesaj",
          component: () => import("@/views/pages/GuncelMutabakat.vue"),

        },
        {
          path: "teklif-siparis-onay/:RECEIPTID/:ACTID/:TRANSTYPE/:TRANSCODE/:EMAIL/:ISLEM",
          name: "TeklifSiparisOnay",
          component: () => import("@/views/pages/TalepSiparisOnayMesaj.vue"),

        },
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/login",
          name: "page-login",
          component: () => import("@/views/pages/Login.vue"),
          meta: {
            rule: "editor"
          }
        },
        {
          path: "/pages/error-404",
          name: "page-error-404",
          component: () => import("@/views/pages/Error404.vue"),
          meta: {
            rule: "editor"
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404"
    }
  ]
});
/*
router.beforeEach((to, from, next) => {
  console.log(to)
  console.log(from)
  console.log(window.location)
  if (window.location.pathname == "/muhasebe-kategorileri") {
    console.log("in")
    next()
   // next({ name: '/muhasebe-kategorileri' })
  } else
    next()
})*/
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
